/**
 * MOCK Code Enforcement violation-type list (Category is reused as the violation-type taxonomy,
 * Kind="case" — SAME entity pattern as question topics / channels / KORA record types). Mirrors
 * koraRecordTypes.ts's shape/role.
 *
 * USE_MOCKS-fallback only — every live-aware surface reads violation types from the real Kind=case
 * Category entities instead (CasesQueuePage/CaseDetailPage/CaseOpenPage via a live admin read;
 * CategoriesAdmin's "Violation types" tab). This mock list is the last-resort fallback if a live
 * fetch returns an empty list (a brand-new tenant with no violation types configured yet) — never
 * imported directly by a resident page (there is no resident-facing case surface at all).
 */
export interface CaseViolationType {
  id: string;
  label: string;
}

export const MOCK_CASE_VIOLATION_TYPES: CaseViolationType[] = [
  { id: "junk-vehicle", label: "Junk / abandoned vehicle" },
  { id: "tall-grass", label: "Tall grass / weeds" },
  { id: "nuisance", label: "Nuisance / debris" },
  { id: "structure", label: "Unsafe / substandard structure" },
  { id: "other", label: "Other" },
];
